import React from "react";
import AdminUsers from "@/pages/AdminUsers";

/**
 * Iter-44: dedicated page reachable from the sidebar Admin group for CEO / ADMIN /
 * GESTIONNAIRE. Re-uses AdminUsers with a route-driven freelance-only filter — the page
 * keeps all of AdminUsers' existing freelance-config + contract upload affordances and
 * automatically renders the FreelancesAtRiskBlock at the top.
 */
export default function AdminFreelancers() {
  return <AdminUsers freelancesOnly />;
}
